import React from 'react';
import styled from 'styled-components';
import PlacesSuggest from './../SearchListing/PlacesSuggest/PlacesSuggest';
import Input from '../../components_new/common/FormComponents/Input';
import submit from './../SearchListing/SearchForm/submit';
import { colors } from './../../tailwind';
import { Flex, Box } from 'rebass';

class SearchInput extends React.Component {
  render() {
    let { change, className, handleSearchChange, location } = this.props;

    return (
      <Flex justifyContent="space-between">
        <Box flex={1} pr={3}>
          <Input
            name="keyword"
            placeholder="Search"
            validationState={null}
            onChange={e => {
              handleSearchChange(e.target.value);
            }}
          />
        </Box>
        <Box flex={1} pl={3}>
          <PlacesSuggest
            label={'Enter your city'}
            className={className}
            location={location}
            handleSubmit={() => {
              change('sw_lat', null);
              change('ne_lat', null);
              change('initialLoad', true);
            }}
          />
        </Box>
      </Flex>
    );
  }
}

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/SearchInput/SearchInput.js